import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'rttd-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: [
        './page-header.component.scss',
        require(`./page-header.component.${environment.brand}.scss`).default.toString()
    ]
})
export class PageHeaderComponent implements OnInit {
    @Input() title: string;
    @Input() id: string;
    @Input() subtitle: string;
    @Input() showBack = false;

    @Output() back: EventEmitter<MouseEvent> = new EventEmitter();

    constructor() { }

    ngOnInit() {
    }

    /**
     * @describe Emits an event when the back button is clicked.
     */
    emitBack(event: MouseEvent) {
        this.back.emit(event);
    }

}
